"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CornerstoneRow = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneRow"));
var _CornerstoneButton = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneButton"));
var _CornerstoneCol = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneCol"));
var _CornerstoneForm = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneForm"));
var _CornerstoneMessage = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneMessage"));
var _Loader = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneLoader/Loader"));
var _CornerstoneDropdownTable = _interopRequireWildcard(require("cornerstone_ui_core/lib/components/CornerstoneDropdownTable"));
require("./setlocation.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const radioStyle = {
  display: "block",
  height: "30px",
  lineHeight: "30px"
};
class SetLocation extends _react.default.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "componentDidMount", () => {
      this.init();
    });
    _defineProperty(this, "init", async () => {
      let d = await this.props.getPersonPysicalSiteClaims();
      if (d && d.physicalSiteClaims && d.physicalSiteClaims.length > 0) {
        d.physicalSiteClaims.map(c => {
          if (c.active === "Y") {
            this.props.setClaimLocation(c.siteDescription);
          }
        });
      }
    });
    _defineProperty(this, "handleReset", () => {
      this.props.handleSubmit();
    });
    _defineProperty(this, "handleSubmit", () => {
      const {
        physicalSiteClaims,
        selectingPersonDetail
      } = this.props;
      try {
        this.props.form.validateFields((err, values) => {
          if (values && !err) {
            physicalSiteClaims && physicalSiteClaims.map(async p => {
              if (values.locationId === p.siteDescription) {
                try {
                  const res = await selectingPersonDetail({
                    userNumId: p.userNumId,
                    primary: p.primary
                  });
                  if (res && res.locationDetail && res.locationDetail.statusMessage) {
                    this.props.setClaimLocation(values.locationId);
                    localStorage.setItem("claimLocation", values.locationId);
                    localStorage.setItem("PPHSID", p.phsId);
                    _CornerstoneMessage.default.success("Location Saved");
                    this.props.handleSubmit();
                  }
                } catch (err) {
                  this.props.handleSubmit();
                  _CornerstoneMessage.default.error(err.message, JSON.parse(localStorage.getItem("toasterOptions")));
                }
              }
            });
          }
        });
      } catch (err) {
        this.props.handleSubmit();
        _CornerstoneMessage.default.error(err.message, JSON.parse(localStorage.getItem("toasterOptions")));
      }
    });
  }
  render() {
    const {
      loading,
      form
    } = this.props;
    const {
      getFieldDecorator
    } = form;
    const {
      rdsLocation,
      physicalSiteClaims = []
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "cornerstone-app td-select-type-loc"
    }, loading ? /*#__PURE__*/_react.default.createElement(_Loader.default, null) : null, /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, null, /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
      className: "input-box"
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, {
      label: "Location"
    }, getFieldDecorator("locationId", {
      initialValue: rdsLocation || null
    })( /*#__PURE__*/_react.default.createElement(_CornerstoneDropdownTable.default, {
      style: {
        width: "100%"
      },
      defaultValue: rdsLocation,
      filterOption: true,
      showSearch: true,
      fixedHeader: true,
      dataSource: (0, _CornerstoneDropdownTable.addKeyTitle)((physicalSiteClaims || []).map(a => ({
        ...a,
        description: a.description || null
      })), "siteDescription", "siteDescription", true),
      columns: [{
        title: "Location",
        dataIndex: "siteDescription",
        key: "siteDescription"
      }]
    }))))), /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, {
      className: "fixedFooter td_select_modal_footer"
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
      className: "col-float",
      span: 30
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneButton.default, {
      className: "ripple button-margin-tdselect",
      onClick: this.handleReset
    }, "Cancel"), /*#__PURE__*/_react.default.createElement(_CornerstoneButton.default, {
      className: "ripple button-margin-tdselect",
      htmlType: "submit",
      onClick: this.handleSubmit,
      type: "primary"
    }, "OK"))));
  }
}
var _default = exports.default = _CornerstoneForm.default.create({
  name: "td-select-type"
})(SetLocation);